import React from "react";

export default function AsyncCollectionState({
  loading,
  error,
  isEmpty,
  loadingMessage = "Loading…",
  emptyMessage,
  onRetry,
  children,
}) {
  if (loading) return <p role="status" className="text-white/70">{loadingMessage}</p>;

  if (error) {
    return (
      <div role="alert" className="rounded-xl border border-amber-300/30 bg-amber-300/10 p-3 text-amber-100">
        <p>{error}</p>
        {onRetry ? (
          <button type="button" onClick={onRetry} className="mt-3 rounded-lg border border-amber-100/30 bg-black/20 px-3 py-2 text-sm font-semibold">
            Retry
          </button>
        ) : null}
      </div>
    );
  }

  if (isEmpty) return <p className="text-white/70">{emptyMessage}</p>;
  return children;
}
